import NumericInput from './NumericInput'

export default NumericInput



// WEBPACK FOOTER //
// ./src/components/Parts/NumericInput/index.js